export class Tenant {
  constructor(public hashId: string, public name: string) {}
}

export class TenantResponse {
  hashId!: string;
  name!: string;
}
